

























































































































































import { deepCopy } from "deep-copy-ts";
import { Dictionary } from "lodash";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  ApiMessage,
  CustomerModel,
  CustomersApi,
  LocationModel,
} from "../../../apis";

@Component({
  components: { ValidationProvider, ValidationObserver },
})
export default class AddLocationNewCustomer extends Vue {
  @Prop({ default: () => [] }) locations: LocationModel[];
  @Prop({ default: () => {} }) item: LocationModel;
  @Prop({ default: () => {} }) customer: CustomerModel;
  @Prop({ default: false }) value: boolean;
  @Prop({ default: "ADD" }) mode: string;
  @Prop({ default: false }) callApi: boolean;

  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  selectedTimeZone = "";
TIMEZONES = [
  {value: "America/Guatemala", text:"(UTC-06:00) Central America"},
  {value: "America/Chicago", text:"(UTC-06:00) Central Time (US and Canada)"},
  {value: "America/Regina", text:"(UTC-06:00) Saskatchewan"},
  {value: "America/Mexico_City", text:"(UTC-06:00) Guadalajara, Mexico City, Monterey"},
  {value: "America/Bogota", text:"(UTC-05:00) Bogota, Lima, Quito"},
  {value: "America/Indiana/Indianapolis", text:"(UTC-05:00) Indiana (East)"},
  {value: "America/New_York", text:"(UTC-05:00) Eastern Time (US and Canada)"},
  {value: "America/Caracas", text:"(UTC-04:00) Caracas"},
  {value: "America/Halifax", text:"(UTC-04:00) Atlantic Time (Canada)"},
  {value: "America/La_Paz", text:"(UTC-04:00) Georgetown, La Paz, Manaus, San Juan"},
  {value: "America/Cuiaba", text:"(UTC-04:00) Cuiaba"},
  {value: "America/St_Johns", text:"(UTC-03:30) Newfoundland"},
  {value: "America/Sao_Paulo", text:"(UTC-03:00) Brasilia"},
  {value: "America/Cayenne", text:"(UTC-03:00) Cayenne, Fortaleza"},
  {value: "America/Argentina/Buenos_Aires", text:"(UTC-03:00) Buenos Aires"},
  {value: "America/Montevideo", text:"(UTC-03:00) Montevideo"},
  {value: "America/Godthab", text:"(UTC-02:00) Greenland"},
  {value: "Etc/GMT+2", text:"(UTC-02:00) Coordinated Universal Time-2"},
  {value: "Atlantic/Cape_Verde", text:"(UTC-01:00) Cape Verde"},
  {value: "Atlantic/Azores", text:"(UTC-01:00) Azores"},
  {value: "Atlantic/Reykjavik", text:"(UTC+00:00) Monrovia, Reykjavik"},
  {value: "Europe/London", text:"(UTC+00:00) Dublin, Edinburgh, Lisbon, London"},
  {value: "Etc/GMT", text:"(UTC+00:00) Coordinated Universal Time"},
  {value: "Africa/Casablanca", text:"(UTC+01:00) Casablanca"},
  {value: "Europe/Berlin", text:"(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"},
  {value: "Europe/Paris", text:"(UTC+01:00) Brussels, Copenhagen, Madrid, Paris"},
  {value: "Africa/Lagos", text:"(UTC+01:00) West Central Africa"},
  {value: "Europe/Budapest", text:"(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"},
  {value: "Europe/Warsaw", text:"(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb"},
  {value: "Africa/Windhoek", text:"(UTC+02:00) Windhoek"},
  {value: "Europe/Kiev", text:"(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"},
  {value: "Africa/Cairo", text:"(UTC+02:00) Cairo"},
  {value: "Africa/Johannesburg", text:"(UTC+02:00) Harare, Pretoria"},
  {value: "Asia/Jerusalem", text:"(UTC+02:00) Jerusalem"},
  {value: "Asia/Beirut", text:"(UTC+02:00) Beirut"},
  {value: "Asia/Damascus", text:"(UTC+03:00) Damascus"},
  {value: "Asia/Amman", text:"(UTC+03:00) Amman"},
  {value: "Europe/Istanbul", text:"(UTC+03:00) Istanbul"},
  {value: "Asia/Baghdad", text:"(UTC+03:00) Baghdad"},
  {value: "Europe/Minsk", text:"(UTC+03:00) Minsk"},
  {value: "Asia/Riyadh", text:"(UTC+03:00) Kuwait, Riyadh"},
  {value: "Africa/Nairobi", text:"(UTC+03:00) Nairobi"},
  {value: "Europe/Moscow", text:"(UTC+03:00) Moscow, St. Petersburg, Volgograd"},
  {value: "Asia/Tehran", text:"(UTC+03:30) Tehran"},
  {value: "Asia/Tbilisi", text:"(UTC+04:00) Tbilisi"},
  {value: "Asia/Yerevan", text:"(UTC+04:00) Yerevan"},
  {value: "Asia/Dubai", text:"(UTC+04:00) Abu Dhabi, Muscat"},
  {value: "Asia/Baku", text:"(UTC+04:00) Baku"},
  {value: "Indian/Mauritius", text:"(UTC+04:00) Port Louis"},
  {value: "Asia/Kabul", text:"(UTC+04:30) Kabul"},
  {value: "Asia/Tashkent", text:"(UTC+05:00) Tashkent"},
  {value: "Asia/Karachi", text:"(UTC+05:00) Islamabad, Karachi"},
  {value: "Asia/Colombo", text:"(UTC+05:30) Sri Jayewardenepura Kotte"},
  {value: "Asia/Kolkata", text:"(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"},
  {value: "Asia/Kathmandu", text:"(UTC+05:45) Kathmandu"},
  {value: "Asia/Almaty", text:"(UTC+06:00) Astana"},
  {value: "Asia/Dhaka", text:"(UTC+06:00) Dhaka"},
  {value: "Asia/Yangon", text:"(UTC+06:30) Yangon"},
  {value: "Asia/Bangkok", text:"(UTC+07:00) Bangkok, Hanoi, Jakarta"},
  {value: "Asia/Novosibirsk", text:"(UTC+07:00) Novosibirsk"},
  {value: "Asia/Krasnoyarsk", text:"(UTC+08:00) Krasnoyarsk"},
  {value: "Asia/Ulaanbaatar", text:"(UTC+08:00) Ulaanbaatar"},
  {value: "Asia/Shanghai", text:"(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi"},
  {value: "Australia/Perth", text:"(UTC+08:00) Perth"},
  {value: "Asia/Singapore", text:"(UTC+08:00) Kuala Lumpur, Singapore"},
  {value: "Asia/Taipei", text:"(UTC+08:00) Taipei"},
  {value: "Asia/Irkutsk", text:"(UTC+09:00) Irkutsk"},
  {value: "Asia/Seoul", text:"(UTC+09:00) Seoul"},
  {value: "Asia/Tokyo", text:"(UTC+09:00) Osaka, Sapporo, Tokyo"},
  {value: "Asia/Yakutsk", text:"(UTC+09:00) Yakutsk"},
  {value: "Australia/Darwin", text:"(UTC+09:30) Darwin"},
  {value: "Australia/Brisbane", text:"(UTC+10:00) Brisbane"},
  {value: "Pacific/Port_Moresby", text:"(UTC+10:00) Guam, Port Moresby"},
  {value: "Pacific/Guadalcanal", text:"(UTC+11:00) Solomon Islands, New Caledonia"},
  {value: "Etc/GMT-12", text:"(UTC+12:00) Coordinated Universal Time+12"},
  {value: "Pacific/Fiji", text:"(UTC+12:00) Fiji, Marshall Islands"},
  {value: "Asia/Magadan", text:"(UTC+12:00) Magadan"},
  {value: "Pacific/Tongatapu", text:"(UTC+13:00) Nuku'alofa"},
  {value: "Pacific/Apia", text:"(UTC+13:00) Samoa"},
];
  locationName = "";
  contact = "";
  address = "";
  remark = "";
  expirationDate = "";
  emails = [];
  useForeignTreatmentProvider = false;

  get show() {
    return this.value;
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  onShow() {
    if (this.mode == "ADD") {
      this.locationName = "";
      this.contact = "";
      this.address = "";
      this.remark = "";
      this.expirationDate = "";
      this.emails = [];
      this.useForeignTreatmentProvider = false;
    }
    if (this.mode == "EDIT") {
      this.locationName = this.item.locationName;
      this.contact = this.item.contact;
      this.address = this.item.address;
      this.remark = this.item.remark;
      this.expirationDate = !this.item.expirationDate
        ? ""
        : moment(this.item.expirationDate).format("YYYY-MM-DD");
      this.emails = this.item.emails;
      this.useForeignTreatmentProvider = !!this.item.useForeignTreatmentProvider;
    }
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  async onSubmit() {
    const zone = this.TIMEZONES.find(z=> z.value === this.selectedTimeZone);
    const selectedTimeZoneText = zone? zone.text: "";
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    const body = {
      locationName: this.locationName,
      address: this.address,
      contact: this.contact,
      remark: this.remark,
      emails: this.emails,
      selectedTimeZoneText: selectedTimeZoneText,
      selectedTimeZone: this.selectedTimeZone,
      expirationDate: !this.expirationDate
        ? ""
        : moment(this.expirationDate).format("YYYY-MM-DD HH:mm"),
      status: "Active",
      useForeignTreatmentProvider: !!this.useForeignTreatmentProvider,
    } as LocationModel;
    if (this.mode === "ADD") {
      if (this.callApi) {
        this.$util.showLoading();
        try {
          await new CustomersApi().updateCustomer({
            id: this.customer.id,
            putCustomerRequest: {
              ...Object.assign({}, this.customer, {
                createdBy: undefined,
                updatedBy: undefined,
              }),
              locations: [...this.locations, body],
            },
          });
          const locations_ = (
            await new CustomersApi().getLocationsByCustomerId({
              id: this.customer.id,
            })
          ).data.data;
          this.$emit("update:locations", locations_);
          this.show = false;
        } catch (error) {
          this.$util.showError(error);
        } finally {
          this.$util.hideLoading();
        }
      } else {
        this.$emit("update:locations", [...this.locations, ...[{ ...body }]]);
        this.show = false;
      }
    } else {
      const locations_ = deepCopy(this.locations);
      const location = locations_.find((val) =>
        this.lodash.isEqual(
          val.locationName.trim().toUpperCase(),
          this.item.locationName.trim().toUpperCase()
        )
      );
      location.selectedTimeZoneText=selectedTimeZoneText;
      location.selectedTimeZone=this.selectedTimeZone;
      location.locationName = this.locationName;
      location.address = this.address;
      location.remark = this.remark;
      location.contact = this.contact;
      location.emails = this.emails;
      location.expirationDate = !this.expirationDate
        ? ""
        : moment(this.expirationDate).format("YYYY-MM-DD HH:mm");
      location.useForeignTreatmentProvider = !!this.useForeignTreatmentProvider;

      if (this.callApi) {
        this.$util.showLoading();
        try {
          await new CustomersApi().updateCustomer({
            id: this.customer.id,
            putCustomerRequest: {
              ...Object.assign({}, this.customer, {
                createdBy: undefined,
                updatedBy: undefined,
              }),
              locations: locations_,
            },
          });
          const locations = (
            await new CustomersApi().getLocationsByCustomerId({
              id: this.customer.id,
            })
          ).data.data;
          this.$emit("update:locations", locations);
          this.show = false;
        } catch (error) {
          this.$util.showError(error);
        } finally {
          this.$util.hideLoading();
        }
      } else {
        this.$emit("update:locations", locations_);
        this.show = false;
      }
    }
  }
}
